import { parseISO, isWithinInterval, isValid } from 'date-fns'

interface BusinessHoursProps {
  today: string
  openAt: string
  closeAt: string
}

export class BusinessHours {
  businessHours: {
    start: Date
    end: Date
  }

  constructor({ today, openAt, closeAt }: BusinessHoursProps) {
    this.businessHours = this.buildBusinessHours({ today, openAt, closeAt })
  }

  private buildBusinessHours({ today, openAt, closeAt }: BusinessHoursProps) {
    const openTimeString = parseISO(openAt).toTimeString().split(' ')[0] // "17:00:00"
    const closeTimeString = parseISO(closeAt).toTimeString().split(' ')[0] // "7:00:00"

    const openTimeDate = parseISO(`${today}T${openTimeString}`)
    const closeTimeDate = parseISO(`${today}T${closeTimeString}`)

    if (!isValid(openTimeDate) || !isValid(closeTimeDate)) {
      throw new Error('Invalid business hours')
    }

    let closeDateTime: Date
    if (openTimeDate > closeTimeDate) {
      const nextDay = new Date(today)
      nextDay.setDate(nextDay.getDate() + 1)
      const nextDayString = nextDay.toISOString().split('T')[0] // YYYY-MM-DD形式
      closeDateTime = parseISO(`${nextDayString}T${closeTimeString}`)
    } else {
      closeDateTime = parseISO(`${today}T${closeTimeString}`)
    }

    if (!isValid(closeDateTime)) {
      throw new Error('Invalid business hours')
    }

    return {
      start: openTimeDate,
      end: closeDateTime,
    }
  }

  isWithin(dateTimeString: string) {
    const dateTimeDate = parseISO(`${dateTimeString}`)

    if (isValid(dateTimeDate) && isValid(this.businessHours.start) && isValid(this.businessHours.end)) {
      return isWithinInterval(dateTimeDate, this.businessHours)
    }

    return false
  }
}
